import { render, staticRenderFns } from "./SaleHistory.vue?vue&type=template&id=458f24ca&scoped=true"
import script from "./SaleHistory.vue?vue&type=script&lang=ts"
export * from "./SaleHistory.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistory.vue?vue&type=style&index=0&id=458f24ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f24ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458f24ca')) {
      api.createRecord('458f24ca', component.options)
    } else {
      api.reload('458f24ca', component.options)
    }
    module.hot.accept("./SaleHistory.vue?vue&type=template&id=458f24ca&scoped=true", function () {
      api.rerender('458f24ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleHistory.vue"
export default component.exports